import React from 'react';
import { TimeframeFilter } from './Dropdown/TimeframeFilter';
import { DepartmentFilter } from './Dropdown/DepartmentFilter';
import { SiteFilter } from './Dropdown/SiteFilter';
import { ModelFilter } from './Dropdown/ModelFilter';
import { RiskRatingFilter } from './Dropdown/RiskRatingFilter';
import { RoleFilter } from './Dropdown/RoleFilter';
import { AssetFilter } from './Dropdown/AssetFilter';
import { IntervalFilter } from './Dropdown/IntervalFilter';
import { QuestionFilter } from './Dropdown/QuestionFilter';
import { DefectStatusTypeFilter } from './Dropdown/DefectStatusTypeFilter';
import { ServiceStatusFilter } from './Dropdown/ServiceStatusFilter';
import { DefectStatusFilter } from './Dropdown/DefectStatusFilter';
import { DefectTypeFilter } from './Dropdown/DefectTypeFilter';
import { ModelStatusFilter } from './Dropdown/ModelStatusFilter';
import { FeedbackStatusFilter } from './Dropdown/FeedbackStatusFilter';
import { WorkOrderFilter } from './Dropdown/WorkOrderFilter';
import { OccurrenceFilter } from './Dropdown/OccurrenceFilter';
import { ServiceFilter } from './Dropdown/ServiceFilter';
import { UserFilter } from './Dropdown/UserFilter';
import { LevelFilter } from './Dropdown/LevelFilter';
import { TableSortFilter } from './Dropdown/TableSortFilter';
import { ViewToggleFilter } from './Dropdown/ViewToggleFilter';
import { AssetViewToggleFilter } from './Dropdown/AssetViewToggleFilter';
import { AssetGroupingFilter } from './Dropdown/AssetGroupingFilter';
import { QuickFilter } from './Dropdown/QuickFilter';
import { ChipsFilter } from './Chips/ChipsFilter';

const FILTER_COMPONENTS = {
  timeframe: TimeframeFilter,
  department: DepartmentFilter,
  site: SiteFilter,
  model: ModelFilter,
  riskRatings: RiskRatingFilter,
  role: RoleFilter,
  asset: AssetFilter,
  interval: IntervalFilter,
  question: QuestionFilter,
  defectStatusType: DefectStatusTypeFilter,
  serviceStatus: ServiceStatusFilter,
  defectStatus: DefectStatusFilter,
  defectType: DefectTypeFilter,
  modelStatus: ModelStatusFilter,
  feedbackStatus: FeedbackStatusFilter,
  workOrder: WorkOrderFilter,
  occurrence: OccurrenceFilter,
  service: ServiceFilter,
  user: UserFilter,
  level: LevelFilter,
  tableSort: TableSortFilter,
  viewToggle: ViewToggleFilter,
  assetViewToggle: AssetViewToggleFilter,
  assetGrouping: AssetGroupingFilter,
  quickFilter: QuickFilter,
  chips: ChipsFilter,
};

export const createFilter = (filterType) => {
  const FilterComponent = FILTER_COMPONENTS[filterType];
  if (!FilterComponent) return null;

  return <FilterComponent key={filterType} />;
}; 
